import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'

import FormWrapper from 'components/form/Wrapper'

import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import projectActions from 'store/modules/project'
import networkActions from 'store/modules/network'
import settings from '../../settings'

const {
  projectSchema,
} = settings

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
  button: {
    marginRight: theme.spacing(2),
  },
}))

const schema = projectSchema

const ProjectEdit = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const id = useSelector(selectors.router.idParam)
  const project = useSelector(selectors.project.collection.item) || {}
  const error = useSelector(selectors.project.errors.save)
  const submitting = useSelector(selectors.project.loading.save)
  const loading = useSelector(selectors.project.loading.get)

  const onSave = (id, values) => dispatch(projectActions.save(id, values))
  const onCancel = () => dispatch(routerActions.navigateTo('project.list'))
  const clearError = () => dispatch(networkActions.clearError('project.save'))

  return (
    <div className={ classes.root }>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={ classes.paper }>
            <Typography variant="h6" gutterBottom>
              Workspace
            </Typography>
            <FormWrapper
              schema={ schema }
              initialValues={ project }
              error={ error }
              onSubmit={ (values) => onSave(id, values) }
              renderButtons={
                ({
                  handleSubmit,
                }) => {
                  return (
                    <React.Fragment>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        onClick={ onCancel }
                      >
                        Cancel
                      </Button>
                      <Button
                        className={ classes.button }
                        type="button"
                        variant="contained"
                        color="primary"
                        disabled={ submitting }
                        onClick={ handleSubmit }
                      >
                        Save
                      </Button>
                    </React.Fragment>
                  )
                }
              }
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default ProjectEdit